export class Slide {
    comments = [];
    content = [{
        title: '',
        text: ''
    }];
    summary = [{
        title: '',
        text: ''
    }];
    blacklist = [];
    feedback = [{
        text: ''
    }];
    intro = false;
    images = [];
    embed = '';
    embedContent = false;
    imagesMobile = [];
    outro = false;
    search = [];
    teaser = '';
    teaseToSlide;
    title = '';
    headers = [''];
    featured_media;
    metaTitle = '';
    metaDescription = '';
    status = 'draft';
    tags = [];
    type = 'slides';
    mlTopic = '';

    constructor(args) {
        this.setProperties(args);
    }
    setProperties(args) {
        for(var i in args) {
            this[i] = args[i];
        }
    }

}